<template>
    <div
        v-bind="$attrs"
        class="filter-buttons"
        :class="{ 'filter-buttons--left-hidden': !filterScrolledLeft, 'filter-buttons--right-hidden': !filterScrolledRight }"
    >
        <h3 v-if="title" class="sr-only">{{ title }}</h3>
        <ProButton
            class="filter-buttons__nudge filter-buttons__nudge--prev"
            @click="filterContainerScroll(scrollAmount * -1)"
            v-show="!filterScrolledLeft"
            aria-hidden="true"
            tabindex="-1"
        >
            <ProIcon icon="arrow-left" />
        </ProButton>

        <div class="filter-buttons__scroll-container" ref="filtersContainer">
            <slot />
        </div>

        <ProButton
            class="filter-buttons__nudge filter-buttons__nudge--next"
            @click="filterContainerScroll(scrollAmount)"
            v-show="!filterScrolledRight"
            aria-hidden="true"
            tabindex="-1"
        >
            <ProIcon icon="arrow-right" />
        </ProButton>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        scrollAmount: {
            type: Number,
            default: 200,
        },
    },

    data: () => {
        return {
            filterScrolledLeft: false,
            filterScrolledRight: false,
        };
    },

    methods: {
        filterContainerScroll(amount) {
            this.$refs.filtersContainer.scrollBy({
                top: 0,
                left: amount,
                behavior: "smooth",
            });
        },

        createFilterButtonObserver() {
            const categories = [...this.$refs.filtersContainer.querySelectorAll(".pro-btn")];

            const first = categories.shift();
            const last = categories.pop();

            let options = {
                root: this.$refs.filtersContainer,
                rootMargin: "0px",
                threshold: [0, 0.98],
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.target == first) {
                        if (entry.intersectionRatio >= 0.98) return (this.filterScrolledLeft = true);
                        return (this.filterScrolledLeft = false);
                    }

                    if (entry.target == last) {
                        if (entry.intersectionRatio >= 0.98) {
                            return (this.filterScrolledRight = true);
                        }
                        return (this.filterScrolledRight = false);
                    }
                });
            }, options);

            observer.observe(first);
            observer.observe(last);
        },
    },

    mounted() {
        this.createFilterButtonObserver();
    },
};
</script>
